import { render, staticRenderFns } from "./RightChevIcon.vue?vue&type=template&id=cbd2551c&"
import script from "./RightChevIcon.vue?vue&type=script&lang=js&"
export * from "./RightChevIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports